"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxSkeletonTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("../../ProductBox/ProductBoxTable/ProductBoxTable.scss");
var ProductBoxSkeletonTable = function ProductBoxSkeletonTable(_ref) {
  var className = _ref.className,
    skeletonRef = _ref.skeletonRef;
  var rootClassName = (0, _classnames["default"])('cds-ProductBoxTable-BodyRow', 'cds-ProductBox--Table', 'cds-Skeleton-Wrapper--Pulse', className);
  return /*#__PURE__*/_react["default"].createElement("tr", {
    className: rootClassName,
    ref: skeletonRef
  }, /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ProductBox-Image cds-Skeleton--Thumb"
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextShort"
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextShort"
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextFull"
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMicro"
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextMicro"
  })), /*#__PURE__*/_react["default"].createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Skeleton--TextShort"
  })));
};
exports.ProductBoxSkeletonTable = ProductBoxSkeletonTable;